// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { submit } from 'redux-form'
import submittedFormIsPristine from './submittedFormIsPristine'

const triggerSearch = formName => dispatch => {
  if (dispatch(submittedFormIsPristine(formName))) {
    // this means that the form had been previously submitted
    // and that no values were changed after the submission.
    // since we know that the form is valid,
    // trigger submit so that the results will auto-populate
    return dispatch(submit(formName))
  }
}

export default triggerSearch
